import React from 'react';
import Sidebar from "react-sidebar";
import { NavBarContent } from './AppMenu';

export const AppSideBar = ({influencers, popularStores, openSideBar, toogleSideBar}) => {
	

	return <Sidebar
        sidebar={<NavBarContent influencers={influencers}
					popularStores={popularStores} onCloseClick={toogleSideBar} />}
        open={openSideBar}
        onSetOpen={toogleSideBar}
		rootClassName="scSideBarRoot"
		contentClassName="scSideBarContent"
		sidebarClassName="scSideBar"
		overlayClassName="scSideOverlay">
			<span></span>
	  </Sidebar>
};

export default AppSideBar;


// WEBPACK FOOTER //
// ./src/views/AppSideBar.js